import React from "react";
import BeylikduzuSidebar from "../Sidebar/BeylikduzuSidebar";
import BeylikduzuOtherServices from "../ServiceAreas/BeylikduzuServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BeylikduzuIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BEYLİKDÜZÜ HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Beylikdüzü’nde profesyonel halı ve koltuk yıkama hizmetiyle evinizdeki hijyen seviyesini artırıyoruz. Modern yaşamın yoğun temposunda temizlik işlemlerini size özel çözümlerle kolaylaştırıyoruz. Beylikdüzü’nün Adnan Kahveci, Barış, Cumhuriyet, Gürpınar, Kavaklı ve Yakuplu gibi tüm mahallelerine ücretsiz servis hizmetimiz vardır.
          </p>

          <p>
            Halılarınız uzman kadromuz tarafından türüne özel şampuanlarla, tam otomatik makinelerde yıkanır. Koltuklarınız ise yerinde buharlı sistemle, leke çözücü ve antibakteriyel ürünlerle derinlemesine temizlenir. Ayrıca yorgan, battaniye, perde ve yatak yıkama gibi tüm tekstil ürünlerinde hizmet sunuyoruz.
          </p>

          <p>
            <strong>Beylikdüzü halı ve koltuk yıkamada sunduğumuz avantajlar:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz adresten alım ve zamanında teslimat</li>
            <li>Organik, çocuk ve evcil hayvan dostu temizlik ürünleri</li>
            <li>Leke çıkarma garantisi ile güvenli temizlik</li>
            <li>Her halı türüne özel yıkama programı</li>
            <li>Koltuk ve yatak yıkamada buhar sistemi</li>
            <li>Modern, tam otomatik halı yıkama makineleri</li>
            <li>Yıkama sonrası steril paketleme</li>
            <li>Hızlı kurutma ve kırışıklık önleyici sistem</li>
            <li>Şeffaf fiyatlandırma ve memnuniyet garantisi</li>
          </ul>

          <p>
            Özellikle hassas halılar (el dokuma, ipek, shaggy) için özel deterjan ve yumuşatıcılar kullanıyoruz. Koltuk kumaşınıza zarar vermeden, derinlemesine temizlik sağlayan buhar makinelerimiz ile bakteriler, akarlar ve kötü kokular tamamen giderilir.
          </p>

          <p>
            Beylikdüzü bölgesinde temizlikte konforu ve profesyonelliği bir arada sunan hizmet anlayışımızla öne çıkıyoruz. İster sezonluk temizlik için ister düzenli bakım için bizden randevu alabilirsiniz. Hemen iletişim sayfamızdan talepte bulunabilir, fiyat bilgisi ve kampanyalarımız hakkında detaylı bilgi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BeylikduzuSidebar />
          <BeylikduzuOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BeylikduzuIntro;
